import { useState, useEffect } from 'react'
import { /* useNavigate, */ useParams, Link } from 'react-router-dom'

import Login from '../login/Login'
import MensajeConexion from '../mensajeConexion/MensajeConexion'
import * as categoriaService from '../servicios/arbolCategoriaService'
import * as categoriaScrapService from '../servicios/categoriaScrapService'

const Categorias = (props) => {
  const [categorias, setCategorias] = useState([])

  // const navigate = useNavigate()

  const { categoria } = useParams()

  useEffect(() => {
    cargarCategorias()
  }, [categoria])

  const cargarCategorias = async () => {
    const { data: categorias } =
      categoria === 'scrap'
        ? await categoriaScrapService.buscarTodosPorScraps(1)
        : await categoriaService.buscarTodos()
    setCategorias(
      categorias.sort((a, b) => {
        return a.descripcion.localeCompare(b.descripcion)
      })
    )
  }

  // const onClick = (idCategoria, descripcion) => {
  //   console.log('clic ', idCategoria, descripcion, categoria === 'scrap')
  //   categoria === 'scrap'
  //     ? navigate(`/Publicaciones/Subcategorias/${idCategoria}`)
  //     : navigate(`/SubCategorias/${idCategoria}/${descripcion}`)
  // }

  return (
    <>
      {localStorage.getItem('empid') === null ? (
        <>
          <MensajeConexion />
          <Login {...props} />
        </>
      ) : (
        <>
          <br />
          <h4>Categorias {categoria === 'scrap' && ' Scrap'}</h4>
          <div className="row">
            {categorias.map((c) => (
              <div className="col-3 item pd-20 pl-60 pr-0" key={c.idCategoria}>
                <Link
                  to={
                    categoria === 'scrap'
                      ? `/Publicaciones/Subcategorias/${c.idCategoria}`
                      : `/SubCategorias/${c.idCategoria}/${c.descripcion}`
                  }
                  name={c.descripcion}
                  // onClick={() => onClick(c.idCategoria, c.descripcion)}
                  className="cabecera"
                >
                  {c.descripcion}
                </Link>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default Categorias
